import * as React from 'react';

const StatusFieldContainer: React.FC = ({ children }) => {
  return (
    <div className="status-field-container full-width-section position-fixed bottom-0 w-100 bg-white border-top pt-3 px-4">
      {children}
    </div>
  );
};

export default StatusFieldContainer;
